import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "output", "outputContainer", "datalist"]
  static values = { detailsUrl: String }

  connect() {
    // Если при загрузке уже что-то выбрано (редактирование), подгружаем данные
    if (this.selectTarget.value) {
      this.inspect()
    }
  }

  async inspect() {
    const sourceId = this.selectTarget.value

    if (!sourceId) {
      this.clearDatalist()
      if (this.hasOutputContainerTarget) this.outputContainerTarget.classList.add("hidden")
      if (this.hasOutputTarget) this.outputTarget.textContent = ""
      return
    }

    const url = this.detailsUrlValue.replace('__SOURCE_ID__', sourceId)

    try {
      const response = await fetch(url, {
        headers: { "Accept": "application/json" }
      })

      if (!response.ok) throw new Error(`Err: ${response.statusText}`)

      const data = await response.json()

      if (data.source_fields && Array.isArray(data.source_fields)) {
        this.populateDatalist(data.source_fields)
      } else {
        this.clearDatalist()
      }

      if (this.hasOutputTarget && this.hasOutputContainerTarget) {
        this.outputTarget.textContent = JSON.stringify(data, null, 2)
        this.outputContainerTarget.classList.remove("hidden")
      }
    } catch (error) {
      console.error("Source inspector error:", error)
    }
  }

  populateDatalist(fields) {
    if (!this.hasDatalistTarget) return

    // Очищаем старые опции
    this.datalistTarget.innerHTML = ''

    fields.forEach(field => {
      const option = document.createElement('option')
      option.value = field
      this.datalistTarget.appendChild(option)
    })
  }

  clearDatalist() {
    if (this.hasDatalistTarget) {
      this.datalistTarget.innerHTML = ''
    }
  }
}